import { petOpenState } from '@atom/setting/jukebox';
import { DragContainer } from '@components/wrapper/DragContainer';
import DraggableWrapper from '@components/wrapper/DraggableWrapper';
import React from 'react';
import { useRecoilState } from 'recoil';
import PetView from './PetView';

const PetDraggable = () => {
  const [open, setOpen] = useRecoilState(petOpenState);

  return (
    <DraggableWrapper direction="bottomRight">
      <DragContainer
        open={open}
        floatingDir="bottom"
        width={420}
        style={{ height: '800px', zIndex: 4, padding: 0 }}
      >
        <PetView />
      </DragContainer>
    </DraggableWrapper>
  );
};

export default PetDraggable;
